module.exports = __webpack_public_path__ + "static/media/writes-on-clipboard-at-the-factory-production-control.12ac4a24.webm";